import React from 'react';
import { UiComponent } from 'components';
import { IQuestion } from 'types';
import { useNavigate, useParams } from 'react-router-dom';
import { FeedbackQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { usePermission } from 'hooks';

function Form() {
  const { id } = useParams();
  const { data, isLoading } = FeedbackQuery.useGet(id || '');
  const { mutate: create } = FeedbackQuery.useCreate();
  const { mutate: update } = FeedbackQuery.useUpdate();

  const navigate = useNavigate();
  const can = usePermission();
  const canSave = can(
    id === undefined ? 'feedback_template:create' : 'feedback_template:update',
  );

  const onCreate = (title: string, questions: IQuestion[]) => {
    const data = { title, questions: JSON.stringify(questions) };
    create(data, {
      onSuccess: () => {
        toast.success('피드백 템플릿 등록이 완료되었습니다.');
        navigate(-1);
      },
      onError: () => {
        toast.error(DEFAULT_ERROR_MESSAGE);
      },
    });
  };

  const onUpdate = (title: string, questions: IQuestion[]) => {
    if (!id) return;

    update(
      { id, title, questions: JSON.stringify(questions) },
      {
        onSuccess: () => {
          toast.success('피드백 템플릿 수정이 완료되었습니다.');
          navigate(-1);
        },
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const onSave = (title: string, questions: IQuestion[]) => {
    if (id === undefined) onCreate(title, questions);
    else onUpdate(title, questions);
  };

  if (isLoading) return null;

  return (
    <div>
      <UiComponent.Forms
        formData={{ title: data?.title, questions: data?.questions }}
        type="feedback"
        onSave={onSave}
        canSave={canSave}
      />
    </div>
  );
}

export default Form;
